import { CalendarOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { findMatchingPreset } from '../../../utils/time.ts'

interface PeriodDependentHeaderComponentProps {
  startDate: dayjs.Dayjs
  endDate: dayjs.Dayjs
}

export const PeriodDependentHeaderComponent: React.FC<
  PeriodDependentHeaderComponentProps
> = ({ startDate, endDate }) => {
  const matchingPreset = findMatchingPreset(startDate, endDate)

  const displayText = matchingPreset
    ? matchingPreset
    : `${startDate.format('YYYY-MM-DD')} to ${endDate.format('YYYY-MM-DD')}`

  return (
    <>
      <CalendarOutlined style={{ color: '#D3A342', marginRight: '5px' }} />
      {`Period-Dependent Data (${displayText})`}
    </>
  )
}
